/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.6.1.0 (NJsonSchema v10.1.21.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class FormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    contactMe(lead: ExternalLeadDto): Promise<FormSubmissionResult> {
        let url_ = this.baseUrl + "/api/form/contact-me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lead);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContactMe(_response);
        });
    }

    protected processContactMe(response: Response): Promise<FormSubmissionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormSubmissionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormSubmissionResult>(<any>null);
    }

    booking(booking: Booking): Promise<FormSubmissionResult> {
        let url_ = this.baseUrl + "/api/form/booking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(booking);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBooking(_response);
        });
    }

    protected processBooking(response: Response): Promise<FormSubmissionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormSubmissionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormSubmissionResult>(<any>null);
    }

    voucher(voucher: Voucher): Promise<FormSubmissionResult> {
        let url_ = this.baseUrl + "/api/form/voucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(voucher);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVoucher(_response);
        });
    }

    protected processVoucher(response: Response): Promise<FormSubmissionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormSubmissionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormSubmissionResult>(<any>null);
    }
}

export class HealthcheckClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    infra(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/infra/lbtest1.html";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInfra(_response);
        });
    }

    protected processInfra(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class FormSubmissionResult implements IFormSubmissionResult {
    submissionId?: string | undefined;
    dlpSubmissionResult?: string | undefined;
    submissionErrorMessage?: string | undefined;
    adminMailErrorMessage?: string | undefined;
    customerMailErrorMessage?: string | undefined;
    submissionSuccess!: boolean;
    dlpSubmissionSuccess!: boolean;
    adminMailSuccess!: boolean;
    customerMailSuccess!: boolean;
    success!: boolean;

    constructor(data?: IFormSubmissionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionId = _data["submissionId"];
            this.dlpSubmissionResult = _data["dlpSubmissionResult"];
            this.submissionErrorMessage = _data["submissionErrorMessage"];
            this.adminMailErrorMessage = _data["adminMailErrorMessage"];
            this.customerMailErrorMessage = _data["customerMailErrorMessage"];
            this.submissionSuccess = _data["submissionSuccess"];
            this.dlpSubmissionSuccess = _data["dlpSubmissionSuccess"];
            this.adminMailSuccess = _data["adminMailSuccess"];
            this.customerMailSuccess = _data["customerMailSuccess"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): FormSubmissionResult {
        data = typeof data === 'object' ? data : {};
        let result = new FormSubmissionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionId"] = this.submissionId;
        data["dlpSubmissionResult"] = this.dlpSubmissionResult;
        data["submissionErrorMessage"] = this.submissionErrorMessage;
        data["adminMailErrorMessage"] = this.adminMailErrorMessage;
        data["customerMailErrorMessage"] = this.customerMailErrorMessage;
        data["submissionSuccess"] = this.submissionSuccess;
        data["dlpSubmissionSuccess"] = this.dlpSubmissionSuccess;
        data["adminMailSuccess"] = this.adminMailSuccess;
        data["customerMailSuccess"] = this.customerMailSuccess;
        data["success"] = this.success;
        return data; 
    }
}

export interface IFormSubmissionResult {
    submissionId?: string | undefined;
    dlpSubmissionResult?: string | undefined;
    submissionErrorMessage?: string | undefined;
    adminMailErrorMessage?: string | undefined;
    customerMailErrorMessage?: string | undefined;
    submissionSuccess: boolean;
    dlpSubmissionSuccess: boolean;
    adminMailSuccess: boolean;
    customerMailSuccess: boolean;
    success: boolean;
}

export class ExternalLeadDto implements IExternalLeadDto {
    offerId?: string | undefined;
    leadDate?: Date | undefined;
    serviceType?: string | undefined;
    dealerCode?: string | undefined;
    classification?: string | undefined;
    customerLegalEntityType?: LegalEntityType | undefined;
    customerTitle?: Titleship | undefined;
    customerName?: string | undefined;
    customerSurname?: string | undefined;
    companyName?: string | undefined;
    customerContactNumber?: string | undefined;
    customerMobileNumber?: string | undefined;
    customerFax?: string | undefined;
    customerEmail?: string | undefined;
    postalAddress1?: string | undefined;
    postalAddress2?: string | undefined;
    postalAddress3?: string | undefined;
    postalCode?: string | undefined;
    physicalAddress1?: string | undefined;
    physicalAddress2?: string | undefined;
    physicalAddress3?: string | undefined;
    physicalCode?: string | undefined;
    province?: Province | undefined;
    country?: Countries | undefined;
    identificationType?: CountryIdType | undefined;
    idRegPassportNumber?: string | undefined;
    csref?: string | undefined;
    siteUrl?: string | undefined;
    sourceUrl?: string | undefined;
    notes?: string | undefined;
    newCarPeriod?: NewCarPeriod | undefined;
    newCarType?: NewDemoPreowned | undefined;
    newCarModel?: string | undefined;
    bodyType?: string | undefined;
    engineType?: string | undefined;
    testDriveModel?: string | undefined;
    testDriveBookingDate?: Date | undefined;
    drivingLicenseNumber?: string | undefined;
    bookServiceModel?: string | undefined;
    bookServiceYear?: string | undefined;
    serviceBookingDate?: Date | undefined;
    licensePlate?: string | undefined;
    vin?: string | undefined;
    tradeIn!: boolean;
    tradeInPeriod?: TradeInPeriod | undefined;
    tradeInBrand?: string | undefined;
    tradeInModel?: string | undefined;
    tradeInYear?: number | undefined;
    tradeInMileage?: number | undefined;
    tradeInValue?: number | undefined;
    financeReference?: string | undefined;
    insuranceQuote!: boolean;
    marketingConsent?: boolean | undefined;
    marketingConsentText?: string | undefined;
    privacy?: boolean | undefined;
    lineOfBusiness?: Lob | undefined;
    automaticQualification?: boolean | undefined;
    automaticQualificationAction?: LeadActivityAction | undefined;
    isTestLead?: boolean | undefined;
    preferredContactTime?: PreferredContactTime | undefined;
    cookieId?: string | undefined;

    constructor(data?: IExternalLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerId = _data["offerId"];
            this.leadDate = _data["leadDate"] ? new Date(_data["leadDate"].toString()) : <any>undefined;
            this.serviceType = _data["serviceType"];
            this.dealerCode = _data["dealerCode"];
            this.classification = _data["classification"];
            this.customerLegalEntityType = _data["customerLegalEntityType"];
            this.customerTitle = _data["customerTitle"];
            this.customerName = _data["customerName"];
            this.customerSurname = _data["customerSurname"];
            this.companyName = _data["companyName"];
            this.customerContactNumber = _data["customerContactNumber"];
            this.customerMobileNumber = _data["customerMobileNumber"];
            this.customerFax = _data["customerFax"];
            this.customerEmail = _data["customerEmail"];
            this.postalAddress1 = _data["postalAddress1"];
            this.postalAddress2 = _data["postalAddress2"];
            this.postalAddress3 = _data["postalAddress3"];
            this.postalCode = _data["postalCode"];
            this.physicalAddress1 = _data["physicalAddress1"];
            this.physicalAddress2 = _data["physicalAddress2"];
            this.physicalAddress3 = _data["physicalAddress3"];
            this.physicalCode = _data["physicalCode"];
            this.province = _data["province"];
            this.country = _data["country"];
            this.identificationType = _data["identificationType"];
            this.idRegPassportNumber = _data["idRegPassportNumber"];
            this.csref = _data["csref"];
            this.siteUrl = _data["siteUrl"];
            this.sourceUrl = _data["sourceUrl"];
            this.notes = _data["notes"];
            this.newCarPeriod = _data["newCarPeriod"];
            this.newCarType = _data["newCarType"];
            this.newCarModel = _data["newCarModel"];
            this.bodyType = _data["bodyType"];
            this.engineType = _data["engineType"];
            this.testDriveModel = _data["testDriveModel"];
            this.testDriveBookingDate = _data["testDriveBookingDate"] ? new Date(_data["testDriveBookingDate"].toString()) : <any>undefined;
            this.drivingLicenseNumber = _data["drivingLicenseNumber"];
            this.bookServiceModel = _data["bookServiceModel"];
            this.bookServiceYear = _data["bookServiceYear"];
            this.serviceBookingDate = _data["serviceBookingDate"] ? new Date(_data["serviceBookingDate"].toString()) : <any>undefined;
            this.licensePlate = _data["licensePlate"];
            this.vin = _data["vin"];
            this.tradeIn = _data["tradeIn"];
            this.tradeInPeriod = _data["tradeInPeriod"];
            this.tradeInBrand = _data["tradeInBrand"];
            this.tradeInModel = _data["tradeInModel"];
            this.tradeInYear = _data["tradeInYear"];
            this.tradeInMileage = _data["tradeInMileage"];
            this.tradeInValue = _data["tradeInValue"];
            this.financeReference = _data["financeReference"];
            this.insuranceQuote = _data["insuranceQuote"];
            this.marketingConsent = _data["marketingConsent"];
            this.marketingConsentText = _data["marketingConsentText"];
            this.privacy = _data["privacy"];
            this.lineOfBusiness = _data["lineOfBusiness"];
            this.automaticQualification = _data["automaticQualification"];
            this.automaticQualificationAction = _data["automaticQualificationAction"];
            this.isTestLead = _data["isTestLead"];
            this.preferredContactTime = _data["preferredContactTime"];
            this.cookieId = _data["cookieId"];
        }
    }

    static fromJS(data: any): ExternalLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerId"] = this.offerId;
        data["leadDate"] = this.leadDate ? this.leadDate.toISOString() : <any>undefined;
        data["serviceType"] = this.serviceType;
        data["dealerCode"] = this.dealerCode;
        data["classification"] = this.classification;
        data["customerLegalEntityType"] = this.customerLegalEntityType;
        data["customerTitle"] = this.customerTitle;
        data["customerName"] = this.customerName;
        data["customerSurname"] = this.customerSurname;
        data["companyName"] = this.companyName;
        data["customerContactNumber"] = this.customerContactNumber;
        data["customerMobileNumber"] = this.customerMobileNumber;
        data["customerFax"] = this.customerFax;
        data["customerEmail"] = this.customerEmail;
        data["postalAddress1"] = this.postalAddress1;
        data["postalAddress2"] = this.postalAddress2;
        data["postalAddress3"] = this.postalAddress3;
        data["postalCode"] = this.postalCode;
        data["physicalAddress1"] = this.physicalAddress1;
        data["physicalAddress2"] = this.physicalAddress2;
        data["physicalAddress3"] = this.physicalAddress3;
        data["physicalCode"] = this.physicalCode;
        data["province"] = this.province;
        data["country"] = this.country;
        data["identificationType"] = this.identificationType;
        data["idRegPassportNumber"] = this.idRegPassportNumber;
        data["csref"] = this.csref;
        data["siteUrl"] = this.siteUrl;
        data["sourceUrl"] = this.sourceUrl;
        data["notes"] = this.notes;
        data["newCarPeriod"] = this.newCarPeriod;
        data["newCarType"] = this.newCarType;
        data["newCarModel"] = this.newCarModel;
        data["bodyType"] = this.bodyType;
        data["engineType"] = this.engineType;
        data["testDriveModel"] = this.testDriveModel;
        data["testDriveBookingDate"] = this.testDriveBookingDate ? this.testDriveBookingDate.toISOString() : <any>undefined;
        data["drivingLicenseNumber"] = this.drivingLicenseNumber;
        data["bookServiceModel"] = this.bookServiceModel;
        data["bookServiceYear"] = this.bookServiceYear;
        data["serviceBookingDate"] = this.serviceBookingDate ? this.serviceBookingDate.toISOString() : <any>undefined;
        data["licensePlate"] = this.licensePlate;
        data["vin"] = this.vin;
        data["tradeIn"] = this.tradeIn;
        data["tradeInPeriod"] = this.tradeInPeriod;
        data["tradeInBrand"] = this.tradeInBrand;
        data["tradeInModel"] = this.tradeInModel;
        data["tradeInYear"] = this.tradeInYear;
        data["tradeInMileage"] = this.tradeInMileage;
        data["tradeInValue"] = this.tradeInValue;
        data["financeReference"] = this.financeReference;
        data["insuranceQuote"] = this.insuranceQuote;
        data["marketingConsent"] = this.marketingConsent;
        data["marketingConsentText"] = this.marketingConsentText;
        data["privacy"] = this.privacy;
        data["lineOfBusiness"] = this.lineOfBusiness;
        data["automaticQualification"] = this.automaticQualification;
        data["automaticQualificationAction"] = this.automaticQualificationAction;
        data["isTestLead"] = this.isTestLead;
        data["preferredContactTime"] = this.preferredContactTime;
        data["cookieId"] = this.cookieId;
        return data; 
    }
}

export interface IExternalLeadDto {
    offerId?: string | undefined;
    leadDate?: Date | undefined;
    serviceType?: string | undefined;
    dealerCode?: string | undefined;
    classification?: string | undefined;
    customerLegalEntityType?: LegalEntityType | undefined;
    customerTitle?: Titleship | undefined;
    customerName?: string | undefined;
    customerSurname?: string | undefined;
    companyName?: string | undefined;
    customerContactNumber?: string | undefined;
    customerMobileNumber?: string | undefined;
    customerFax?: string | undefined;
    customerEmail?: string | undefined;
    postalAddress1?: string | undefined;
    postalAddress2?: string | undefined;
    postalAddress3?: string | undefined;
    postalCode?: string | undefined;
    physicalAddress1?: string | undefined;
    physicalAddress2?: string | undefined;
    physicalAddress3?: string | undefined;
    physicalCode?: string | undefined;
    province?: Province | undefined;
    country?: Countries | undefined;
    identificationType?: CountryIdType | undefined;
    idRegPassportNumber?: string | undefined;
    csref?: string | undefined;
    siteUrl?: string | undefined;
    sourceUrl?: string | undefined;
    notes?: string | undefined;
    newCarPeriod?: NewCarPeriod | undefined;
    newCarType?: NewDemoPreowned | undefined;
    newCarModel?: string | undefined;
    bodyType?: string | undefined;
    engineType?: string | undefined;
    testDriveModel?: string | undefined;
    testDriveBookingDate?: Date | undefined;
    drivingLicenseNumber?: string | undefined;
    bookServiceModel?: string | undefined;
    bookServiceYear?: string | undefined;
    serviceBookingDate?: Date | undefined;
    licensePlate?: string | undefined;
    vin?: string | undefined;
    tradeIn: boolean;
    tradeInPeriod?: TradeInPeriod | undefined;
    tradeInBrand?: string | undefined;
    tradeInModel?: string | undefined;
    tradeInYear?: number | undefined;
    tradeInMileage?: number | undefined;
    tradeInValue?: number | undefined;
    financeReference?: string | undefined;
    insuranceQuote: boolean;
    marketingConsent?: boolean | undefined;
    marketingConsentText?: string | undefined;
    privacy?: boolean | undefined;
    lineOfBusiness?: Lob | undefined;
    automaticQualification?: boolean | undefined;
    automaticQualificationAction?: LeadActivityAction | undefined;
    isTestLead?: boolean | undefined;
    preferredContactTime?: PreferredContactTime | undefined;
    cookieId?: string | undefined;
}

/** 0 = PrivateIndividual 1 = SelfEmployed 2 = Company 3 = CompanyOther 4 = CloseCorporation 5 = Trust 6 = Partnership 7 = SoleProprietor 8 = Government 9 = Incorporated */
export enum LegalEntityType {
    PrivateIndividual = 0,
    SelfEmployed = 1,
    Company = 2,
    CompanyOther = 3,
    CloseCorporation = 4,
    Trust = 5,
    Partnership = 6,
    SoleProprietor = 7,
    Government = 8,
    Incorporated = 9,
}

/** 1 = Ms 2 = Mr 3 = Adv 4 = Dr 5 = Prof 6 = Mrs 7 = Rev 8 = Judge */
export enum Titleship {
    Ms = 1,
    Mr = 2,
    Adv = 3,
    Dr = 4,
    Prof = 5,
    Mrs = 6,
    Rev = 7,
    Judge = 8,
}

/** 0 = EP 1 = FS 2 = GP 3 = KZ 4 = NP 5 = NC 6 = MP 7 = NW 8 = WP 9 = XB 10 = XL 11 = XN 12 = XS 13 = XF 14 = F */
export enum Province {
    EP = 0,
    FS = 1,
    GP = 2,
    KZ = 3,
    NP = 4,
    NC = 5,
    MP = 6,
    NW = 7,
    WP = 8,
    XB = 9,
    XL = 10,
    XN = 11,
    XS = 12,
    XF = 13,
    F = 14,
}

/** 0 = AD 1 = AE 2 = AF 3 = AG 4 = AI 5 = AL 6 = AM 7 = AN 8 = AO 9 = AQ 10 = AR 11 = AS 12 = AT 13 = AU 14 = AW 15 = AZ 16 = BA 17 = BB 18 = BD 19 = BE 20 = BF 21 = BG 22 = BH 23 = BI 24 = BJ 25 = BM 26 = BN 27 = BO 28 = BR 29 = BS 30 = BT 31 = BV 32 = BW 33 = BY 34 = BZ 35 = CA 36 = CC 37 = CD 38 = CF 39 = CG 40 = CH 41 = CI 42 = CK 43 = CL 44 = CM 45 = CN 46 = CO 47 = CR 48 = CU 49 = CV 50 = CX 51 = CY 52 = CZ 53 = DE 54 = DJ 55 = DK 56 = DM 57 = DO 58 = DZ 59 = EC 60 = EE 61 = EG 62 = EH 63 = ER 64 = ES 65 = ET 66 = FI 67 = FJ 68 = FK 69 = FM 70 = FO 71 = FR 72 = GA 73 = GB 74 = GD 75 = GE 76 = GF 77 = GH 78 = GI 79 = GL 80 = GM 81 = GN 82 = GP 83 = GQ 84 = GR 85 = GS 86 = GT 87 = GU 88 = GW 89 = GY 90 = HK 91 = HM 92 = HN 93 = HR 94 = HT 95 = HU 96 = ID 97 = IE 98 = IL 99 = IN 100 = IO 101 = IQ 102 = IR 103 = IS 104 = IT 105 = JM 106 = JO 107 = JP 108 = KE 109 = KG 110 = KH 111 = KI 112 = KM 113 = KN 114 = KP 115 = KR 116 = KW 117 = KY 118 = KZ 119 = LA 120 = LB 121 = LC 122 = LI 123 = LK 124 = LR 125 = LS 126 = LT 127 = LU 128 = LV 129 = LY 130 = MA 131 = MC 132 = MD 133 = MG 134 = MH 135 = MK 136 = ML 137 = MM 138 = MN 139 = MO 140 = MP 141 = MQ 142 = MR 143 = MS 144 = MT 145 = MU 146 = MV 147 = MW 148 = MX 149 = MY 150 = MZ 151 = NA 152 = NC 153 = NE 154 = NF 155 = NG 156 = NI 157 = NL 158 = NO 159 = NP 160 = NR 161 = NU 162 = NZ 163 = OM 164 = PA 165 = PE 166 = PF 167 = PG 168 = PH 169 = PK 170 = PL 171 = PM 172 = PN 173 = PR 174 = PT 175 = PW 176 = PY 177 = QA 178 = RE 179 = RO 180 = RU 181 = RW 182 = SA 183 = SB 184 = SC 185 = SD 186 = SE 187 = SG 188 = SH 189 = SI 190 = SJ 191 = SK 192 = SL 193 = SM 194 = SN 195 = SO 196 = SR 197 = ST 198 = SV 199 = SY 200 = SZ 201 = TC 202 = TD 203 = TF 204 = TG 205 = TH 206 = TJ 207 = TK 208 = TM 209 = TN 210 = TO 211 = TP 212 = TR 213 = TT 214 = TV 215 = TW 216 = TZ 217 = UA 218 = UG 219 = UM 220 = US 221 = UY 222 = UZ 223 = VA 224 = VC 225 = VE 226 = VG 227 = VI 228 = VN 229 = VU 230 = WF 231 = WS 232 = YE 233 = YT 234 = YU 235 = ZA 236 = ZM 237 = ZW */
export enum Countries {
    AD = 0,
    AE = 1,
    AF = 2,
    AG = 3,
    AI = 4,
    AL = 5,
    AM = 6,
    AN = 7,
    AO = 8,
    AQ = 9,
    AR = 10,
    AS = 11,
    AT = 12,
    AU = 13,
    AW = 14,
    AZ = 15,
    BA = 16,
    BB = 17,
    BD = 18,
    BE = 19,
    BF = 20,
    BG = 21,
    BH = 22,
    BI = 23,
    BJ = 24,
    BM = 25,
    BN = 26,
    BO = 27,
    BR = 28,
    BS = 29,
    BT = 30,
    BV = 31,
    BW = 32,
    BY = 33,
    BZ = 34,
    CA = 35,
    CC = 36,
    CD = 37,
    CF = 38,
    CG = 39,
    CH = 40,
    CI = 41,
    CK = 42,
    CL = 43,
    CM = 44,
    CN = 45,
    CO = 46,
    CR = 47,
    CU = 48,
    CV = 49,
    CX = 50,
    CY = 51,
    CZ = 52,
    DE = 53,
    DJ = 54,
    DK = 55,
    DM = 56,
    DO = 57,
    DZ = 58,
    EC = 59,
    EE = 60,
    EG = 61,
    EH = 62,
    ER = 63,
    ES = 64,
    ET = 65,
    FI = 66,
    FJ = 67,
    FK = 68,
    FM = 69,
    FO = 70,
    FR = 71,
    GA = 72,
    GB = 73,
    GD = 74,
    GE = 75,
    GF = 76,
    GH = 77,
    GI = 78,
    GL = 79,
    GM = 80,
    GN = 81,
    GP = 82,
    GQ = 83,
    GR = 84,
    GS = 85,
    GT = 86,
    GU = 87,
    GW = 88,
    GY = 89,
    HK = 90,
    HM = 91,
    HN = 92,
    HR = 93,
    HT = 94,
    HU = 95,
    ID = 96,
    IE = 97,
    IL = 98,
    IN = 99,
    IO = 100,
    IQ = 101,
    IR = 102,
    IS = 103,
    IT = 104,
    JM = 105,
    JO = 106,
    JP = 107,
    KE = 108,
    KG = 109,
    KH = 110,
    KI = 111,
    KM = 112,
    KN = 113,
    KP = 114,
    KR = 115,
    KW = 116,
    KY = 117,
    KZ = 118,
    LA = 119,
    LB = 120,
    LC = 121,
    LI = 122,
    LK = 123,
    LR = 124,
    LS = 125,
    LT = 126,
    LU = 127,
    LV = 128,
    LY = 129,
    MA = 130,
    MC = 131,
    MD = 132,
    MG = 133,
    MH = 134,
    MK = 135,
    ML = 136,
    MM = 137,
    MN = 138,
    MO = 139,
    MP = 140,
    MQ = 141,
    MR = 142,
    MS = 143,
    MT = 144,
    MU = 145,
    MV = 146,
    MW = 147,
    MX = 148,
    MY = 149,
    MZ = 150,
    NA = 151,
    NC = 152,
    NE = 153,
    NF = 154,
    NG = 155,
    NI = 156,
    NL = 157,
    NO = 158,
    NP = 159,
    NR = 160,
    NU = 161,
    NZ = 162,
    OM = 163,
    PA = 164,
    PE = 165,
    PF = 166,
    PG = 167,
    PH = 168,
    PK = 169,
    PL = 170,
    PM = 171,
    PN = 172,
    PR = 173,
    PT = 174,
    PW = 175,
    PY = 176,
    QA = 177,
    RE = 178,
    RO = 179,
    RU = 180,
    RW = 181,
    SA = 182,
    SB = 183,
    SC = 184,
    SD = 185,
    SE = 186,
    SG = 187,
    SH = 188,
    SI = 189,
    SJ = 190,
    SK = 191,
    SL = 192,
    SM = 193,
    SN = 194,
    SO = 195,
    SR = 196,
    ST = 197,
    SV = 198,
    SY = 199,
    SZ = 200,
    TC = 201,
    TD = 202,
    TF = 203,
    TG = 204,
    TH = 205,
    TJ = 206,
    TK = 207,
    TM = 208,
    TN = 209,
    TO = 210,
    TP = 211,
    TR = 212,
    TT = 213,
    TV = 214,
    TW = 215,
    TZ = 216,
    UA = 217,
    UG = 218,
    UM = 219,
    US = 220,
    UY = 221,
    UZ = 222,
    VA = 223,
    VC = 224,
    VE = 225,
    VG = 226,
    VI = 227,
    VN = 228,
    VU = 229,
    WF = 230,
    WS = 231,
    YE = 232,
    YT = 233,
    YU = 234,
    ZA = 235,
    ZM = 236,
    ZW = 237,
}

/** 1 = Rsa 2 = RsaPassport 3 = UkPassport 4 = EuPassport 5 = OtherPassport */
export enum CountryIdType {
    Rsa = 1,
    RsaPassport = 2,
    UkPassport = 3,
    EuPassport = 4,
    OtherPassport = 5,
}

/** 0 = OneMonth 1 = Threemonths 2 = SixMonths 3 = OneYear */
export enum NewCarPeriod {
    OneMonth = 0,
    Threemonths = 1,
    SixMonths = 2,
    OneYear = 3,
}

/** 0 = New 1 = Demo 2 = Preowned */
export enum NewDemoPreowned {
    New = 0,
    Demo = 1,
    Preowned = 2,
}

/** 0 = OneMonth 1 = Threemonths 2 = SixMonths 3 = OneYear */
export enum TradeInPeriod {
    OneMonth = 0,
    Threemonths = 1,
    SixMonths = 2,
    OneYear = 3,
}

/** 1 = Mbpc 2 = Mbcv 3 = Van 4 = Bus 6 = Ftl 7 = Smart 8 = Cjd 9 = Colt 10 = Mitsubishi 11 = Maybach 12 = Unimog 13 = FusoCanter */
export enum Lob {
    Mbpc = 1,
    Mbcv = 2,
    Van = 3,
    Bus = 4,
    Ftl = 6,
    Smart = 7,
    Cjd = 8,
    Colt = 9,
    Mitsubishi = 10,
    Maybach = 11,
    Unimog = 12,
    FusoCanter = 13,
}

/** 0 = Qualify 1 = Unqualify 2 = Reject 3 = Reschedule 4 = Start 5 = ChangeQueue 6 = RescheduleAndChangeQueue 7 = Escalated 8 = WinBack 9 = Reopen 10 = Close 11 = MercedesLostSale 12 = DealerReschedule 13 = DealerClose 14 = SalesQueryCreated */
export enum LeadActivityAction {
    Qualify = 0,
    Unqualify = 1,
    Reject = 2,
    Reschedule = 3,
    Start = 4,
    ChangeQueue = 5,
    RescheduleAndChangeQueue = 6,
    Escalated = 7,
    WinBack = 8,
    Reopen = 9,
    Close = 10,
    MercedesLostSale = 11,
    DealerReschedule = 12,
    DealerClose = 13,
    SalesQueryCreated = 14,
}

/** 0 = EightToTwelve 1 = TwelveToFour 2 = FourToEight */
export enum PreferredContactTime {
    EightToTwelve = 0,
    TwelveToFour = 1,
    FourToEight = 2,
}

export class Booking implements IBooking {
    id?: string | undefined;
    _id?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    voucher?: Voucher | undefined;
    hasPaid?: boolean | undefined;
    hasAcceptedIndemnity?: boolean | undefined;
    spectator?: ComponentEventSpectator | undefined;
    course?: Course | undefined;
    customer?: Customer | undefined;
    r_customerFullName?: string | undefined;
    r_courseTypeName?: string | undefined;
    r_courseDate?: Date | undefined;
    notes?: string | undefined;

    constructor(data?: IBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this._id = _data["_id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.voucher = _data["Voucher"] ? Voucher.fromJS(_data["Voucher"]) : <any>undefined;
            this.hasPaid = _data["HasPaid"];
            this.hasAcceptedIndemnity = _data["HasAcceptedIndemnity"];
            this.spectator = _data["Spectator"] ? ComponentEventSpectator.fromJS(_data["Spectator"]) : <any>undefined;
            this.course = _data["Course"] ? Course.fromJS(_data["Course"]) : <any>undefined;
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : <any>undefined;
            this.r_customerFullName = _data["r_customerFullName"];
            this.r_courseTypeName = _data["r_courseTypeName"];
            this.r_courseDate = _data["r_courseDate"] ? new Date(_data["r_courseDate"].toString()) : <any>undefined;
            this.notes = _data["Notes"];
        }
    }

    static fromJS(data: any): Booking {
        data = typeof data === 'object' ? data : {};
        let result = new Booking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["_id"] = this._id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["Voucher"] = this.voucher ? this.voucher.toJSON() : <any>undefined;
        data["HasPaid"] = this.hasPaid;
        data["HasAcceptedIndemnity"] = this.hasAcceptedIndemnity;
        data["Spectator"] = this.spectator ? this.spectator.toJSON() : <any>undefined;
        data["Course"] = this.course ? this.course.toJSON() : <any>undefined;
        data["Customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["r_customerFullName"] = this.r_customerFullName;
        data["r_courseTypeName"] = this.r_courseTypeName;
        data["r_courseDate"] = this.r_courseDate ? this.r_courseDate.toISOString() : <any>undefined;
        data["Notes"] = this.notes;
        return data; 
    }
}

export interface IBooking {
    id?: string | undefined;
    _id?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    voucher?: Voucher | undefined;
    hasPaid?: boolean | undefined;
    hasAcceptedIndemnity?: boolean | undefined;
    spectator?: ComponentEventSpectator | undefined;
    course?: Course | undefined;
    customer?: Customer | undefined;
    r_customerFullName?: string | undefined;
    r_courseTypeName?: string | undefined;
    r_courseDate?: Date | undefined;
    notes?: string | undefined;
}

export class Voucher implements IVoucher {
    id?: string | undefined;
    _id?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    code?: string | undefined;
    expiry?: Date | undefined;
    booking?: Booking | undefined;
    customerFor?: Customer | undefined;
    customerBy?: Customer | undefined;
    hasPaid?: boolean | undefined;
    courseType?: CourseType | undefined;
    r_customerForName?: string | undefined;
    r_customerByName?: string | undefined;
    r_courseTypeName?: string | undefined;

    constructor(data?: IVoucher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this._id = _data["_id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.code = _data["Code"];
            this.expiry = _data["Expiry"] ? new Date(_data["Expiry"].toString()) : <any>undefined;
            this.booking = _data["Booking"] ? Booking.fromJS(_data["Booking"]) : <any>undefined;
            this.customerFor = _data["CustomerFor"] ? Customer.fromJS(_data["CustomerFor"]) : <any>undefined;
            this.customerBy = _data["CustomerBy"] ? Customer.fromJS(_data["CustomerBy"]) : <any>undefined;
            this.hasPaid = _data["HasPaid"];
            this.courseType = _data["CourseType"] ? CourseType.fromJS(_data["CourseType"]) : <any>undefined;
            this.r_customerForName = _data["r_customerForName"];
            this.r_customerByName = _data["r_customerByName"];
            this.r_courseTypeName = _data["r_courseTypeName"];
        }
    }

    static fromJS(data: any): Voucher {
        data = typeof data === 'object' ? data : {};
        let result = new Voucher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["_id"] = this._id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["Code"] = this.code;
        data["Expiry"] = this.expiry ? this.expiry.toISOString() : <any>undefined;
        data["Booking"] = this.booking ? this.booking.toJSON() : <any>undefined;
        data["CustomerFor"] = this.customerFor ? this.customerFor.toJSON() : <any>undefined;
        data["CustomerBy"] = this.customerBy ? this.customerBy.toJSON() : <any>undefined;
        data["HasPaid"] = this.hasPaid;
        data["CourseType"] = this.courseType ? this.courseType.toJSON() : <any>undefined;
        data["r_customerForName"] = this.r_customerForName;
        data["r_customerByName"] = this.r_customerByName;
        data["r_courseTypeName"] = this.r_courseTypeName;
        return data; 
    }
}

export interface IVoucher {
    id?: string | undefined;
    _id?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    code?: string | undefined;
    expiry?: Date | undefined;
    booking?: Booking | undefined;
    customerFor?: Customer | undefined;
    customerBy?: Customer | undefined;
    hasPaid?: boolean | undefined;
    courseType?: CourseType | undefined;
    r_customerForName?: string | undefined;
    r_customerByName?: string | undefined;
    r_courseTypeName?: string | undefined;
}

export class Customer implements ICustomer {
    id?: string | undefined;
    _id?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    r_fullName?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    driversLicense?: string | undefined;
    marketingConsent?: boolean | undefined;
    marketingConsentText?: string | undefined;
    title?: ENUM_CUSTOMER_TITLE | undefined;
    dietary?: string | undefined;
    postalCode?: string | undefined;
    notes?: string | undefined;
    corporateCustomer?: boolean | undefined;
    bookings?: Booking[] | undefined;
    vouchersFor?: Voucher[] | undefined;
    vouchersBy?: Voucher[] | undefined;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this._id = _data["_id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.r_fullName = _data["r_fullName"];
            this.phone = _data["Phone"];
            this.email = _data["Email"];
            this.driversLicense = _data["DriversLicense"];
            this.marketingConsent = _data["MarketingConsent"];
            this.marketingConsentText = _data["MarketingConsentText"];
            this.title = _data["Title"];
            this.dietary = _data["Dietary"];
            this.postalCode = _data["PostalCode"];
            this.notes = _data["Notes"];
            this.corporateCustomer = _data["CorporateCustomer"];
            if (Array.isArray(_data["Bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["Bookings"])
                    this.bookings!.push(Booking.fromJS(item));
            }
            if (Array.isArray(_data["VouchersFor"])) {
                this.vouchersFor = [] as any;
                for (let item of _data["VouchersFor"])
                    this.vouchersFor!.push(Voucher.fromJS(item));
            }
            if (Array.isArray(_data["VouchersBy"])) {
                this.vouchersBy = [] as any;
                for (let item of _data["VouchersBy"])
                    this.vouchersBy!.push(Voucher.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["_id"] = this._id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["r_fullName"] = this.r_fullName;
        data["Phone"] = this.phone;
        data["Email"] = this.email;
        data["DriversLicense"] = this.driversLicense;
        data["MarketingConsent"] = this.marketingConsent;
        data["MarketingConsentText"] = this.marketingConsentText;
        data["Title"] = this.title;
        data["Dietary"] = this.dietary;
        data["PostalCode"] = this.postalCode;
        data["Notes"] = this.notes;
        data["CorporateCustomer"] = this.corporateCustomer;
        if (Array.isArray(this.bookings)) {
            data["Bookings"] = [];
            for (let item of this.bookings)
                data["Bookings"].push(item.toJSON());
        }
        if (Array.isArray(this.vouchersFor)) {
            data["VouchersFor"] = [];
            for (let item of this.vouchersFor)
                data["VouchersFor"].push(item.toJSON());
        }
        if (Array.isArray(this.vouchersBy)) {
            data["VouchersBy"] = [];
            for (let item of this.vouchersBy)
                data["VouchersBy"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomer {
    id?: string | undefined;
    _id?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    r_fullName?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    driversLicense?: string | undefined;
    marketingConsent?: boolean | undefined;
    marketingConsentText?: string | undefined;
    title?: ENUM_CUSTOMER_TITLE | undefined;
    dietary?: string | undefined;
    postalCode?: string | undefined;
    notes?: string | undefined;
    corporateCustomer?: boolean | undefined;
    bookings?: Booking[] | undefined;
    vouchersFor?: Voucher[] | undefined;
    vouchersBy?: Voucher[] | undefined;
}

/** 0 = Mr 1 = Mrs 2 = Ms 3 = Dr 4 = Prof */
export enum ENUM_CUSTOMER_TITLE {
    Mr = 0,
    Mrs = 1,
    Ms = 2,
    Dr = 3,
    Prof = 4,
}

export class CourseType implements ICourseType {
    id?: string | undefined;
    _id?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    name?: string | undefined;
    price?: number | undefined;
    description?: string | undefined;
    venue?: string | undefined;
    agenda?: ComponentEventSchedule[] | undefined;
    duration?: ENUM_COURSETYPE_DURATION | undefined;
    shortDescription?: string | undefined;
    image?: UploadFile | undefined;
    slug?: string | undefined;
    isActive?: boolean | undefined;
    notes?: string | undefined;
    courseLogo?: UploadFile | undefined;
    courseLogoMainSlider?: UploadFile | undefined;
    courses?: Course[] | undefined;
    vouchers?: Voucher[] | undefined;

    constructor(data?: ICourseType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this._id = _data["_id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.name = _data["Name"];
            this.price = _data["Price"];
            this.description = _data["Description"];
            this.venue = _data["Venue"];
            if (Array.isArray(_data["Agenda"])) {
                this.agenda = [] as any;
                for (let item of _data["Agenda"])
                    this.agenda!.push(ComponentEventSchedule.fromJS(item));
            }
            this.duration = _data["Duration"];
            this.shortDescription = _data["ShortDescription"];
            this.image = _data["Image"] ? UploadFile.fromJS(_data["Image"]) : <any>undefined;
            this.slug = _data["Slug"];
            this.isActive = _data["IsActive"];
            this.notes = _data["Notes"];
            this.courseLogo = _data["CourseLogo"] ? UploadFile.fromJS(_data["CourseLogo"]) : <any>undefined;
            this.courseLogoMainSlider = _data["CourseLogoMainSlider"] ? UploadFile.fromJS(_data["CourseLogoMainSlider"]) : <any>undefined;
            if (Array.isArray(_data["Courses"])) {
                this.courses = [] as any;
                for (let item of _data["Courses"])
                    this.courses!.push(Course.fromJS(item));
            }
            if (Array.isArray(_data["Vouchers"])) {
                this.vouchers = [] as any;
                for (let item of _data["Vouchers"])
                    this.vouchers!.push(Voucher.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourseType {
        data = typeof data === 'object' ? data : {};
        let result = new CourseType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["_id"] = this._id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["Name"] = this.name;
        data["Price"] = this.price;
        data["Description"] = this.description;
        data["Venue"] = this.venue;
        if (Array.isArray(this.agenda)) {
            data["Agenda"] = [];
            for (let item of this.agenda)
                data["Agenda"].push(item.toJSON());
        }
        data["Duration"] = this.duration;
        data["ShortDescription"] = this.shortDescription;
        data["Image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["Slug"] = this.slug;
        data["IsActive"] = this.isActive;
        data["Notes"] = this.notes;
        data["CourseLogo"] = this.courseLogo ? this.courseLogo.toJSON() : <any>undefined;
        data["CourseLogoMainSlider"] = this.courseLogoMainSlider ? this.courseLogoMainSlider.toJSON() : <any>undefined;
        if (Array.isArray(this.courses)) {
            data["Courses"] = [];
            for (let item of this.courses)
                data["Courses"].push(item.toJSON());
        }
        if (Array.isArray(this.vouchers)) {
            data["Vouchers"] = [];
            for (let item of this.vouchers)
                data["Vouchers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICourseType {
    id?: string | undefined;
    _id?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    name?: string | undefined;
    price?: number | undefined;
    description?: string | undefined;
    venue?: string | undefined;
    agenda?: ComponentEventSchedule[] | undefined;
    duration?: ENUM_COURSETYPE_DURATION | undefined;
    shortDescription?: string | undefined;
    image?: UploadFile | undefined;
    slug?: string | undefined;
    isActive?: boolean | undefined;
    notes?: string | undefined;
    courseLogo?: UploadFile | undefined;
    courseLogoMainSlider?: UploadFile | undefined;
    courses?: Course[] | undefined;
    vouchers?: Voucher[] | undefined;
}

export class ComponentEventSchedule implements IComponentEventSchedule {
    id?: string | undefined;
    _id?: string | undefined;
    time?: string | undefined;
    description?: string | undefined;

    constructor(data?: IComponentEventSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this._id = _data["_id"];
            this.time = _data["Time"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): ComponentEventSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentEventSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["_id"] = this._id;
        data["Time"] = this.time;
        data["Description"] = this.description;
        return data; 
    }
}

export interface IComponentEventSchedule {
    id?: string | undefined;
    _id?: string | undefined;
    time?: string | undefined;
    description?: string | undefined;
}

/** 0 = FullDay 1 = HalfDay */
export enum ENUM_COURSETYPE_DURATION {
    FullDay = 0,
    HalfDay = 1,
}

export class UploadFile implements IUploadFile {
    id?: string | undefined;
    _id?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    name?: string | undefined;
    alternativeText?: string | undefined;
    caption?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    formats?: any | undefined;
    hash?: string | undefined;
    ext?: string | undefined;
    mime?: string | undefined;
    size!: number;
    url?: string | undefined;
    previewUrl?: string | undefined;
    provider?: string | undefined;
    provider_metadata?: any | undefined;
    related?: Morph[] | undefined;

    constructor(data?: IUploadFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this._id = _data["_id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.alternativeText = _data["alternativeText"];
            this.caption = _data["caption"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.formats = _data["formats"];
            this.hash = _data["hash"];
            this.ext = _data["ext"];
            this.mime = _data["mime"];
            this.size = _data["size"];
            this.url = _data["url"];
            this.previewUrl = _data["previewUrl"];
            this.provider = _data["provider"];
            this.provider_metadata = _data["provider_metadata"];
            if (Array.isArray(_data["related"])) {
                this.related = [] as any;
                for (let item of _data["related"])
                    this.related!.push(Morph.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UploadFile {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["_id"] = this._id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["alternativeText"] = this.alternativeText;
        data["caption"] = this.caption;
        data["width"] = this.width;
        data["height"] = this.height;
        data["formats"] = this.formats;
        data["hash"] = this.hash;
        data["ext"] = this.ext;
        data["mime"] = this.mime;
        data["size"] = this.size;
        data["url"] = this.url;
        data["previewUrl"] = this.previewUrl;
        data["provider"] = this.provider;
        data["provider_metadata"] = this.provider_metadata;
        if (Array.isArray(this.related)) {
            data["related"] = [];
            for (let item of this.related)
                data["related"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUploadFile {
    id?: string | undefined;
    _id?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    name?: string | undefined;
    alternativeText?: string | undefined;
    caption?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    formats?: any | undefined;
    hash?: string | undefined;
    ext?: string | undefined;
    mime?: string | undefined;
    size: number;
    url?: string | undefined;
    previewUrl?: string | undefined;
    provider?: string | undefined;
    provider_metadata?: any | undefined;
    related?: Morph[] | undefined;
}

export class Morph implements IMorph {

    constructor(data?: IMorph) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Morph {
        data = typeof data === 'object' ? data : {};
        let result = new Morph();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IMorph {
}

export class Course implements ICourse {
    id?: string | undefined;
    _id?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    date?: Date | undefined;
    isActive?: boolean | undefined;
    registrationOpen?: Date | undefined;
    registrationClose?: Date | undefined;
    courseType?: CourseType | undefined;
    r_totalBookings?: number | undefined;
    totalSpaces?: number | undefined;
    r_availableSpaces?: number | undefined;
    corporateEvent?: boolean | undefined;
    notes?: string | undefined;
    r_courseType?: string | undefined;
    bookings?: Booking[] | undefined;

    constructor(data?: ICourse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this._id = _data["_id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.isActive = _data["IsActive"];
            this.registrationOpen = _data["RegistrationOpen"] ? new Date(_data["RegistrationOpen"].toString()) : <any>undefined;
            this.registrationClose = _data["RegistrationClose"] ? new Date(_data["RegistrationClose"].toString()) : <any>undefined;
            this.courseType = _data["CourseType"] ? CourseType.fromJS(_data["CourseType"]) : <any>undefined;
            this.r_totalBookings = _data["r_totalBookings"];
            this.totalSpaces = _data["TotalSpaces"];
            this.r_availableSpaces = _data["r_availableSpaces"];
            this.corporateEvent = _data["CorporateEvent"];
            this.notes = _data["Notes"];
            this.r_courseType = _data["r_courseType"];
            if (Array.isArray(_data["Bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["Bookings"])
                    this.bookings!.push(Booking.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Course {
        data = typeof data === 'object' ? data : {};
        let result = new Course();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["_id"] = this._id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["IsActive"] = this.isActive;
        data["RegistrationOpen"] = this.registrationOpen ? this.registrationOpen.toISOString() : <any>undefined;
        data["RegistrationClose"] = this.registrationClose ? this.registrationClose.toISOString() : <any>undefined;
        data["CourseType"] = this.courseType ? this.courseType.toJSON() : <any>undefined;
        data["r_totalBookings"] = this.r_totalBookings;
        data["TotalSpaces"] = this.totalSpaces;
        data["r_availableSpaces"] = this.r_availableSpaces;
        data["CorporateEvent"] = this.corporateEvent;
        data["Notes"] = this.notes;
        data["r_courseType"] = this.r_courseType;
        if (Array.isArray(this.bookings)) {
            data["Bookings"] = [];
            for (let item of this.bookings)
                data["Bookings"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICourse {
    id?: string | undefined;
    _id?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    date?: Date | undefined;
    isActive?: boolean | undefined;
    registrationOpen?: Date | undefined;
    registrationClose?: Date | undefined;
    courseType?: CourseType | undefined;
    r_totalBookings?: number | undefined;
    totalSpaces?: number | undefined;
    r_availableSpaces?: number | undefined;
    corporateEvent?: boolean | undefined;
    notes?: string | undefined;
    r_courseType?: string | undefined;
    bookings?: Booking[] | undefined;
}

export class ComponentEventSpectator implements IComponentEventSpectator {
    id?: string | undefined;
    _id?: string | undefined;
    name?: string | undefined;
    dietary?: string | undefined;

    constructor(data?: IComponentEventSpectator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this._id = _data["_id"];
            this.name = _data["Name"];
            this.dietary = _data["Dietary"];
        }
    }

    static fromJS(data: any): ComponentEventSpectator {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentEventSpectator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["_id"] = this._id;
        data["Name"] = this.name;
        data["Dietary"] = this.dietary;
        return data; 
    }
}

export interface IComponentEventSpectator {
    id?: string | undefined;
    _id?: string | undefined;
    name?: string | undefined;
    dietary?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}